import { PermissionsEnum } from '@app-enums/permissions';
import {
  hasPermission,
  IHasRequiredPermissions,
  PermissionCheckModeEnum,
  validateExcludedPermissions,
  validateRequiredPermissions,
  validateUserPermissions,
} from 'zaions-tool-kit';

export const hasPfPermission = ({
  permission,
  userPermissions,
}: {
  userPermissions: PermissionsEnum[];
  permission: PermissionsEnum;
}): boolean => hasPermission<PermissionsEnum>({ permission, userPermissions });

export const validatePfRequiredPermissions = ({
  userPermissions,
  requiredPermissions = [],
  checkModeForRequiredPermissions = PermissionCheckModeEnum.every,
}: {
  userPermissions: Array<PermissionsEnum>;
  requiredPermissions?: Array<PermissionsEnum>;
  checkModeForRequiredPermissions?: PermissionCheckModeEnum;
}): boolean =>
  validateRequiredPermissions<PermissionsEnum>({
    userPermissions,
    checkModeForRequiredPermissions,
    requiredPermissions,
  });

export const validatePfExcludedPermissions = ({
  userPermissions,
  excludedPermissions = [], // to check for permissions that, if present, will hide the component
  checkModeForExcludedPermissions = PermissionCheckModeEnum.every,
}: {
  userPermissions: Array<PermissionsEnum>;
  excludedPermissions?: Array<PermissionsEnum>;
  checkModeForExcludedPermissions?: PermissionCheckModeEnum;
}): boolean =>
  validateExcludedPermissions<PermissionsEnum>({
    userPermissions,
    checkModeForExcludedPermissions,
    excludedPermissions,
  });

export const validatePfUserPermissions = ({
  userPermissions,
  requiredPermissions = [],
  excludedPermissions = [], // to check for permissions that, if present, will hide the component
  checkModeForRequiredPermissions = PermissionCheckModeEnum.every,
  checkModeForExcludedPermissions = PermissionCheckModeEnum.every,
}: IHasRequiredPermissions<PermissionsEnum>): boolean =>
  validateUserPermissions<PermissionsEnum>({
    userPermissions,
    checkModeForExcludedPermissions,
    checkModeForRequiredPermissions,
    excludedPermissions,
    requiredPermissions,
  });
